var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _ellipse2, _g3, _g4, _g5, _path12, _path13, _path14, _g6, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path15, _ellipse7, _ellipse8, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOinqSuccess = function SvgOinqSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 433.924 444.432"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "oinq_success_svg__a",
    x1: 0.5,
    y1: -64.725,
    x2: 0.5,
    y2: -63.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242929"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2148",
    transform: "translate(5256.407 -816.206)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2142"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4435",
    d: "M-5190.338 1092.52s-30.423-29.911-36.939-47.3c0 0-10.682-10.8-16.54 2.4-14.873-.91-14.129 13.964-10.064 28.042s42.531 82.864 61.512 87.922 35.686-29.56 35.686-29.56 3.362-9.08-33.655-41.504Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4436",
    d: "M-5190.338 1092.52s-30.423-29.911-36.939-47.3c0 0-10.682-10.8-16.54 2.4-14.873-.91-14.129 13.964-10.064 28.042a76.513 76.513 0 0 0 4.256 10.232c10.655-9.3 22.544-14.184 32.287-4.161 11.816 11.958 5.254 35.077-3.368 53.264 10.273 14.61 20.825 26.593 28.337 28.587 18.981 5.058 35.686-29.56 35.686-29.56s3.362-9.08-33.655-41.504Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4437",
    d: "M-5248.623 1087.959a90.09 90.09 0 0 1-5.258-12.3c-4.055-14.077-4.809-28.952 10.064-28.042 5.858-13.194 16.54-2.4 16.54-2.4 2.114 5.627 6.733 12.576 12.014 19.389a67.554 67.554 0 0 0-33.36 23.353Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4438",
    d: "M-5228.657 1047.539s-2.656-4.129-6.177-4.539-5.747 3.889-4.929 9.257c-3.19-2.612-8.2-.005-9.063 7.7s6.84 12.773 15.713 8.6 13.432-6.806 10.767-10.946-6.311-10.072-6.311-10.072Z",
    fill: "#4b5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4439",
    d: "M-5228.035 1049.887s-2.13-4.8-5.169-5.654-5.183 3.708-1.2 7.506 8.27 2.036 6.369-1.852Z",
    fill: "#7e8390"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2143"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4440",
    d: "M-4886.99 1035.589s24.7-31.193 28.826-48.73c0 0 8.641-11.246 15.4 1.478 13.525-1.7 14.418 13.042 12.184 27.173s-30.185 84.174-47.034 90.191-35.81-27.3-35.81-27.3-4.038-8.783 26.434-42.812Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4441",
    d: "M-4886.99 1035.589s24.7-31.193 28.826-48.73c0 0 8.641-11.246 15.4 1.478 13.525-1.7 14.418 13.042 12.184 27.173a75.923 75.923 0 0 1-2.816 10.341c-10.742-8.619-22.147-12.809-30.009-2.38-9.557 12.452-1.1 34.947 8.72 52.458-7.863 14.99-16.26 27.4-22.929 29.772-16.848 6.018-35.81-27.3-35.81-27.3s-4.038-8.783 26.434-42.812Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4442",
    d: "M-4834.092 1027.953a89.179 89.179 0 0 0 3.514-12.443c2.225-14.129 1.341-28.871-12.184-27.173-6.761-12.724-15.4-1.478-15.4-1.478-1.34 5.673-4.836 12.789-8.951 19.806a66.542 66.542 0 0 1 33.021 21.288Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4443",
    d: "M-4856.654 989.079s2-4.224 5.177-4.817 5.674 3.535 5.493 8.884c2.646-2.753 7.508-.446 9.116 7.126s-4.913 12.99-13.481 9.347-13.022-6-11.018-10.239 4.713-10.301 4.713-10.301Z",
    fill: "#4b5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4444",
    d: "M-4856.975 991.433s1.443-4.854 4.135-5.865 5.139 3.386 1.9 7.353-7.365 2.456-6.035-1.488Z",
    fill: "#7e8390"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4445",
    d: "M-4830.963 1086.163a24.655 24.655 0 0 1-4.44.75c-1.84.2-3.38.28-4.44.31 4.37-10.33-4.42-25.6-15.42-24.6-5.08.46-6 1-9 5s-2.68 9.29.62 13.49a25.231 25.231 0 0 0 14.22 9.14c-4.93 6.73-11.65 7.49-19.95 7.56-3.08 0-8.13.14-12.4-.93v1a13.257 13.257 0 0 1-2.66 7.93c13.24 1.82 27.7-.18 36.92-8.83a30.69 30.69 0 0 0 4.58-4.6c.3-.37.58-.75.85-1.14a17.078 17.078 0 0 0 11.19-1c6.11-2.93 8.36-11.2 8.41-11.18a9.507 9.507 0 0 1-1.71 2.9 13.748 13.748 0 0 1-6.77 4.2Zm-14.8-2.72c-2.36 1.92-6.84.32-10-3.57s-3.84-8.61-1.48-10.53 6.84-.32 10 3.58 3.83 8.6 1.48 10.52Z",
    fill: "#3b9f60"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4446",
    d: "m-4857.213 1096.593-.42-.2c-3.46 1.19-7.38 1.43-11.74 1.46a70.8 70.8 0 0 1-8.94-.31l-1.24 8.75c11.82.76 24-1.71 32.08-9.31a30.6 30.6 0 0 0 4.58-4.6c.29-.36.56-.73.83-1.11 1-2.45 1.56-4.12 1.56-4.12-3.197 4.71-16.71 9.44-16.71 9.44Z",
    fill: "#191919",
    opacity: 0.29,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4447",
    d: "M-4894.333 1001.513c13.21-17.93 31.74-66.5-2-65.88-28.7.52-56.25 15-64.93 19.93-34.93-10.27-69-9.27-73.08-8.49 0 0-34.19-3.75-72.5 9.3-6.69-4-35.87-20.18-66.32-20.74-34.62-.63-14.16 50.57-.94 67.24a146.437 146.437 0 0 0-10.6 15.4c-48.77 81.37-13.83 201.32 85.93 233.32 39.66 12.71 166.64 24 209.9-54.67 33.43-60.8 20.02-153.15-5.46-195.41Z",
    fill: "#4db96e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4448",
    d: "M-4894.333 1001.513c12-16.33 28.46-58 5.85-64.92 17.15 13.06-2.94 51-14.81 46.08-10.05-3.51-33.28-19.78-52.11-30.28-2.41 1.24-4.4 2.34-5.84 3.17h-.1c19.69 11.69 50.53 29.79 57.13 48.22 24.66 68.85 26.64 131.27-13.69 191.1-25.57 37.91-78.09 49.5-117.8 52.71a223.732 223.732 0 0 1-96.78-11.46 152.755 152.755 0 0 0 33.71 15.46c39.66 12.71 166.64 24 209.9-54.67 33.43-60.8 20.02-153.15-5.46-195.41Z",
    fill: "#3b9f60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4449",
    d: "M-5089.7 958.083s-86.761 28.1-103.2 89.93c-13.7 51.29 7.31 125.06 53.881 157.38s149.68 26.69 183.56-6.63c43.3-42.58 20.65-79.2-9.46-80.74 0 0-38.93-17-53.54-.1-7.31 10.55-39.643 62.5-42.383 45.636-52.089 31.891-90.49 3.314-56.386-46.142-14.69 4.51 14.163-48.607 48.163-75.607 42.29-33.58 109.2-9.887 135.266 38.113 19.7 36.22 29.23-78.51-14.61-101s-94.714-27.86-141.291-20.84Z",
    fill: "#6fc282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4450",
    d: "M-4938.083 971.593s28.1 19 32.24 26.44c6.6-.83 16.52-29.75 14.87-39.67s-29.727-7.4-47.11 13.23Z",
    fill: "#6fc282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4451",
    d: "M-5124.643 978.913s-28.1 19-32.23 26.44c-6.61-.82-16.53-29.76-14.83-39.66s29.703-7.44 47.06 13.22Z",
    fill: "#6fc282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4452",
    d: "M-4890.973 958.393a5.444 5.444 0 0 0-.873-2.119 5.434 5.434 0 0 0-1.667-1.571c-.94 10.06-3.16 25.68-13 27.47-9.25 2.06-21.46-7.31-29.55-12.83-.69.74-1.37 1.49-2 2.28 0 0 28.1 19 32.24 26.44 6.58-.83 16.5-29.75 14.85-39.67Z",
    fill: "#3b9f60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4453",
    d: "M-5159.013 1015.053s-28.31 31-33.79 68.49 11.87 21.92 24.66-17.35 28.31-59.36 32.87-68.5-12.78 4.57-23.74 17.36Z",
    fill: "#a6d7b7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4454",
    d: "M-5029.633 946.673a32.235 32.235 0 0 0-4.69.47s-2.71-.38-7.47-.56v17.68a3.632 3.632 0 0 0 .336 1.513 3.64 3.64 0 0 0 .934 1.237 7.343 7.343 0 0 0 5.012 1.936 7.34 7.34 0 0 0 4.988-2 3.178 3.178 0 0 0 .712-1.1 3.165 3.165 0 0 0 .208-1.292Z",
    fill: "url(#oinq_success_svg__a)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4455",
    d: "M-4959.765 941.3a2.807 2.807 0 0 1-1.482-.331 5.819 5.819 0 0 1-1.558-1.154c-21.733-22.034-32.049-9.784-32.473-9.262a1.312 1.312 0 0 1-.75.452 2.168 2.168 0 0 1-1.047-.063 5.321 5.321 0 0 1-2.33-1.55 6.5 6.5 0 0 1-1.5-2.585 2.371 2.371 0 0 1 .208-2.1c.145-.158 13.488-16.03 40.412 11.283a6.592 6.592 0 0 1 1.533 2.492 2.6 2.6 0 0 1-.065 2.131 1.359 1.359 0 0 1-.948.687Z",
    fill: "#3b9f60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4456",
    d: "M-5111.393 951.272a1.479 1.479 0 0 1-1.069-.3 1.586 1.586 0 0 1-.276-1.614 5.145 5.145 0 0 1 1.273-2.113c24.372-24.6 39.385-14.4 39.529-14.294a1.116 1.116 0 0 1 .431.633 2 2 0 0 1 0 .934 3.977 3.977 0 0 1-.439 1.093 5.9 5.9 0 0 1-.806 1.085 6.471 6.471 0 0 1-1.05.912 5.069 5.069 0 0 1-1.135.6 2.906 2.906 0 0 1-1.047.2 1.411 1.411 0 0 1-.8-.235c-.5-.336-12.175-8.1-31.745 11.636a6.153 6.153 0 0 1-1.441 1.047 3.528 3.528 0 0 1-1.425.416Z",
    fill: "#3b9f60"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 71",
    cx: 25.356,
    cy: 31.671,
    rx: 25.356,
    ry: 31.671,
    transform: "translate(-5025.735 960.076)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 72",
    cx: 29.114,
    cy: 40.313,
    rx: 29.114,
    ry: 40.313,
    transform: "translate(-5099.664 956.7)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4457",
    d: "M-5010.221 1012.939a12.75 12.75 0 0 0 12.75-12.749 12.75 12.75 0 0 0-12.75-12.749 12.75 12.75 0 0 0-12.749 12.749 12.75 12.75 0 0 0 12.749 12.749Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4458",
    d: "M-5000.868 991.529c1.225 5.149 1.489 14.748-10.4 21.345a12.73 12.73 0 0 0 7.356-1.617 12.744 12.744 0 0 0 5.157-5.492 12.738 12.738 0 0 0 1.15-7.444 12.73 12.73 0 0 0-3.263-6.792Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4459",
    d: "M-5011.8 997.75a2.772 2.772 0 0 0 2.772-2.772 2.773 2.773 0 0 0-2.772-2.772 2.773 2.773 0 0 0-2.772 2.772 2.772 2.772 0 0 0 2.772 2.772Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2145"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4460",
    d: "M-5061.7 1017.982a12.629 12.629 0 0 0 12.629-12.629 12.629 12.629 0 0 0-12.629-12.629 12.629 12.629 0 0 0-12.629 12.629 12.63 12.63 0 0 0 12.629 12.629Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4461",
    d: "M-5052.44 996.773c1.214 5.1 1.475 14.609-10.307 21.144a12.615 12.615 0 0 0 7.288-1.6 12.614 12.614 0 0 0 5.107-5.44 12.614 12.614 0 0 0 1.14-7.374 12.616 12.616 0 0 0-3.228-6.73Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4462",
    d: "M-5063.273 1002.936a2.746 2.746 0 0 0 2.746-2.746 2.746 2.746 0 0 0-2.746-2.746 2.747 2.747 0 0 0-2.746 2.746 2.747 2.747 0 0 0 2.746 2.746Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2146"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4463",
    d: "M-5054.125 1026.585s-35.086 4.627-52.45 36.382c-12.3 22.133-6.927 56.889 29.336 55.7s56.453 1.364 75.843 8.642 48.855 5.746 55.92-10.807 9.006-43.644-11.636-64.022-53.488-34.736-97.013-25.895Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4464",
    d: "M-5103.454 1077.074s-6.378 28.784 21.141 33.381 44.47-2.783 88.663 10.107 49.961-16.8 44.483-40.5-35.4-46.77-70.944-50.345-72.363 9.904-83.343 47.357Z",
    fill: "#4db96e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4465",
    d: "M-5061.9 1077.51c-1.091 6.521-6.54 11.052-12.173 10.1s-9.293-6.991-8.211-13.514 6.541-11.063 12.164-10.117 9.32 6.999 8.22 13.531Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4466",
    d: "M-5058.954 1081.323c-1.092 6.521-6.54 11.052-12.165 10.116s-9.3-6.992-8.21-13.524 6.54-11.053 12.164-10.116 9.302 7.001 8.211 13.524Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4467",
    d: "M-4971.781 1088.506c-1.093 6.532-6.591 11.056-12.164 10.116s-9.3-6.992-8.212-13.514 6.532-11.063 12.165-10.116 9.303 6.992 8.211 13.514Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4468",
    d: "M-4968.831 1092.33c-1.091 6.522-6.54 11.053-12.174 10.115s-9.3-6.992-8.21-13.524 6.539-11.052 12.164-10.116 9.307 6.963 8.22 13.525Z",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4469",
    d: "M-5018.259 1033.446s-26.187-4.37-34.642 4.628c-1.579 4.081 11.12 11.416 26.338 8.723s18.723-13.341 8.304-13.351Z",
    fill: "#a6d7b7"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4470",
    d: "m-5112.829 1163.046 144.188-20.818s45.609 46.993-2.948 67.929-127.723-18.012-141.24-47.111Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4471",
    d: "M-5112.829 1163.046s89.756 12.744 129.344 5.4l1.924-4.019 2.375 3.09c4.5-1.128 8.106-2.6 10.545-4.474v-20.818Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4472",
    d: "M-5060.445 1202.885s42.894-28.217 100.449-1.158c-.004 0-33.352 31.531-100.449 1.158Z",
    fill: "#e41f5c"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2147"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 73",
    cx: 9.897,
    cy: 29.153,
    rx: 9.897,
    ry: 29.153,
    transform: "translate(-5024.473 860.389)",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 74",
    cx: 7.464,
    cy: 29.153,
    rx: 7.464,
    ry: 29.153,
    transform: "translate(-5019.608 860.592)",
    fill: "#e0ff17"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 75",
    cx: 9.897,
    cy: 29.153,
    rx: 9.897,
    ry: 29.153,
    transform: "translate(-5049.9 823.531)",
    fill: "#b9a400"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 76",
    cx: 7.464,
    cy: 29.153,
    rx: 7.464,
    ry: 29.153,
    transform: "translate(-5045.035 823.734)",
    fill: "#e0ff17"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 77",
    cx: 5.223,
    cy: 15.385,
    rx: 5.223,
    ry: 15.385,
    transform: "translate(-5017.367 816.206)",
    fill: "#b9a400"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 78",
    cx: 3.939,
    cy: 15.385,
    rx: 3.939,
    ry: 15.385,
    transform: "translate(-5014.799 816.313)",
    fill: "#e0ff17"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4473",
    d: "M-5040.053 945.043s-1.83 20.7.86 23.36-6.81-.6-6.81-.6l-4.49-16 2.43-7.85Z",
    fill: "#3b9f60"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 79",
    cx: 9.897,
    cy: 29.153,
    rx: 9.897,
    ry: 29.153,
    transform: "translate(-5044.243 906.373)",
    fill: "#b9a400"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 80",
    cx: 7.464,
    cy: 29.153,
    rx: 7.464,
    ry: 29.153,
    transform: "translate(-5039.377 906.576)",
    fill: "#e0ff17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4474",
    d: "M-5027.258 945.984s-2.355 19.759-5.045 22.419 6.81-.6 6.81-.6l4.49-16-2.43-7.85Z",
    fill: "#3b9f60"
  }))));
};
export default SvgOinqSuccess;